<template>
	<div class="container">
	<div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>  
		<div class="row">
			<div class="col-md-12">
				<div class="widget-wrap">
					<div class="widget-container margin-top-0">
						<div class="widget-content">
							<div class="row">
								<div class="col-md-12">
									<div class="row w-section-header">
										<div class="col-xs-2 text-left">
										</div>
								
										<div class="col-xs-8 center">
											<h1>Account info & settings</h1>             							
										</div>
										<div class="col-xs-2 text-right">
										</div>						                    	                						
									</div>
								</div>
							</div>
							<form class="j-forms" novalidate>
                    			<div class="form-content">
									<div class="row">
										<div class="col-md-12" v-if="updatedProfile">
											<div class="success-message">
												<span><i class="fa fa-check"></i> Profile updated!</span>
											</div>
											<br>
										</div>
										<div class="col-md-12" v-if="settErr">
											<div class="error-message">
												<span v-html="settErr"></span>
											</div>
											<br>
										</div> 	
									</div>   
									             				
									<div class="row">										 
										<div class="col-sm-6 unit">
											<label class="label">First name</label>
											<div class="input">
												<label class="icon-left" for="first_name">
													<i class="fa fa-user"></i>
												</label>
												<input class="form-control required-group" type="text" v-model="first_name" v-bind:placeholder="utente.first_name" >
											</div>
										</div>
										<div class="col-sm-6 unit">
											<label class="label">Last name</label>
											<div class="input">
												<label class="icon-left" for="last_name">
													<i class="fa fa-user"></i>
												</label>
												<input type="text" class="required-group form-control" v-model="last_name" v-bind:placeholder="utente.last_name" >
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-6 unit">
											<label class="label">Username</label>
											<div class="input">
												<label class="icon-left" for="username">
													<i class="fa fa-user"></i>
												</label>
												<input class="form-control required-group" type="text" name="username" id="username" v-bind:value="utente.username" readonly>
											</div>
										</div>
										<div class="col-sm-6 unit">
											<label class="label">Email</label>
											<div class="input">
												<label class="icon-left" for="email">
													<i class="fa fa-envelope"></i>
												</label>
												<input type="text" class="required-group form-control" v-model="email"  v-bind:placeholder="utente.email" v-on:focus="changeEmail()" @click="changeEmail()">
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-12 unit">
				                          <label>
				                            <span class="label-text"><span>How would you like to hear from us?<sup>*</sup></span></span>
				                          </label>
				                          <div class="form-check">
				                 
				                            <label>
				                              <input type="checkbox" name="gdpr_email" value="true" v-model="gdpr_email"> <span class="label-text"><span>Newsletter (no monkey business, only good stuff: videos,tips and customized offers)</span></span>
				                            </label>
				                                 
				                            <label>
				                              <input type="checkbox" value="true" name="gdpr_advertising" v-model="gdpr_advertising"> <span class="label-text"><span>Customized online ads, promo and news</span></span>
				                            </label>
				                          </div>
				                          <div class="clearfix"></div>
				                       </div>
									</div>
									<div class="row">
										<div class="col-xs-12 unit">
											<div v-if="changedEmail" class="alert alert-warning" role="alert">
                    							<strong>Warning!</strong> Changing your email address all of your authorizations will be invalidated. You will be requested to re-authorize your products.
                							</div>											
											<button type="button" class="btn btn-primary pull-left" @click="updateProfile()" >Update profile</button>
											<download-csv
												class   = "btn btn-default pull-right"
												:data   = "export_data"
												name    = "userdata.csv">

												<i class="fa fa-user"></i> Export user data

											</download-csv>
											<download-csv
												class   = "btn btn-default pull-right"
												:data   = "ordersExport"
												name    = "orders.csv">

												<i class="fa fa-shopping-cart"></i> Export orders data

											</download-csv>
								
										</div>										
									</div>

									<hr>
									
									<div v-if="pwdErr" class="row">
										<div class="col-xs-12 unit">
											<div class="error-message">
												<p>{{ pwdErr }}</p>
											</div>										
										</div>																			
									</div>

									<div class="row">										
										<div class="col-sm-6 unit">
											<label class="label">Current password</label>
											<div class="input">
												<label class="icon-left" for="current_pwd">
													<i class="fa fa-key"></i>
												</label>
												<input class="form-control required-group" type="password" v-model="current_pwd" >
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-sm-6 unit">
											<label class="label">New password</label>
											<div class="input">
												<label class="icon-left" for="new_pwd">
													<i class="fa fa-key"></i>
												</label>
												<input type="password" v-validate="'required|verify_password'" class="required-group form-control" v-model="new_pwd" name="new_pwd" ref="new_pwd">
												<span v-show="errors.has('new_pwd')" class="error-view">{{ errors.first('new_pwd') }}</span>
											</div>
										</div>										
										<div class="col-sm-6 unit">
											<label class="label">Confirm new password</label>
											<div class="input">
												<label class="icon-left" for="new_pwd_confirm">
													<i class="fa fa-key"></i>
												</label>
												<input type="password" v-validate="'required|confirmed:new_pwd'" data-vv-as="new_pwd" class="required-group form-control" name="new_pwd_confirm" v-model="new_pwd_confirm">
												<span v-show="errors.has('new_pwd_confirm')" class="error-view">{{ errors.first('new_pwd_confirm') }}</span>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 unit">
											<button type="button" class="btn btn-primary pull-left" @click="changePwd()">Change password</button>
											<button type="button" class="btn btn-danger pull-right" @click="deleteAccount()">Delete my account</button>
										</div>										
									</div>									
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import auth from '../auth'
	import VeeValidate from 'vee-validate'
	  VeeValidate.Validator.extend('verify_password', {
	      getMessage: field => 'The password must be at least 8 characters and must contain an uppercase letter, a lowercase letter, a number, and one special character (E.g. , . _ & ? etc)',
	      validate: value => {
	          var strongRegex = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/g;
	          return strongRegex.test(value);
	      }
	  }) 
	export default {
		data(){
			return{
				settErr:'',
				pwdErr:'',
				first_name: '',
				last_name: '',
				username:'',
				email:'',
				gdpr_email:'',
				gdpr_advertising:'',
				current_pwd:'',
				new_pwd:'',
				new_pwd_confirm:'',
				changedEmail: false,
				updatedProfile: false,
				loading: false,
				mycompany: localStorage.getItem('reseller'),
				myproducts: [],
				myorders:[],
				export_data: [],
				ordersExport: [],
				deleteUser: 'cazzo',
				get utente(){
          			return JSON.parse(localStorage.getItem('userdata')) || 0;
        		}
			}
		},
		watch: {
		    deleteUser: function (val) {
		      console.log(val)
		     }
		},
		methods: {
			changeEmail(){
				this.changedEmail = true
			},
      		updateProfile(){
      			this.settErr = ''
      			var context = this
      			var confirmMsg = ''      			
      			if (this.email != this.utente.email) {
      				confirmMsg = 'Changing your email address all of your license will be deactivated.<br/>'
      			}
      			bootbox.confirm(confirmMsg+'Are you sure?<br/>', function(result){
      				if(result){
      					auth.updateProfile(context, context.first_name, context.last_name, context.gdpr_email, context.gdpr_advertising, context.email, context.utente.email)
      				}
      			});
      			
      		},
      		changePwd(){
		      	this.$validator.validateAll()
		        if (this.$validator.errors.items.length == 0){
	      			if (this.current_pwd && this.new_pwd && this.new_pwd_confirm){
	      				auth.changePwd(this, this.utente.email, this.utente.username, this.current_pwd, this.new_pwd, this.new_pwd_confirm)
	      			}
	      		}
	      			
      		},
      		deleteAccount(){
      			bootbox.confirm('<h3>Pay attention!</h3>By confirming, you will <b>permanently remove</b> your account data from Audio Modeling Customer Portal. You will loose the access to the portal, but you will still able to authorize your products through the license keys.<br/><br/>Type <b>DELETE</b> and press OK to proceed<br/><input type="text" class="form-control" id="deleteUser" >', function(result){
      				if(result){
      					if(document.getElementById('deleteUser').value  == 'DELETE'){
      						auth.deleteAccount(this, this.email)
      					} else {
      						return false
      					}
      				}
      			});
      		}
		},
	    created(){
		    VeeValidate.Validator.extend('verify_password', {
	          getMessage: field => 'The password must be at least 8 characters and must contain an uppercase letter, a lowercase letter, a number, and one special character (E.g. , . _ & ? etc)',
	          validate: value => {
	            var strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^\w\s])(?=.{8,})/g;
	            return strongRegex.test(value);
	          }
	     	}) 
	    	console.log(this.utente)
	    	this.first_name = this.utente.first_name
	    	this.last_name = this.utente.last_name
	        this.email = this.utente.email
	        this.gdpr_email = (this.utente.gdpr_email == 'true') ? true : false
	        this.gdpr_advertising = (this.utente.gdpr_advertising == 'true') ? true : false
	        auth.getOrders(this, this.utente.id, this.mycompany)
	        this.export_data = [
		        {
		        	'username': this.utente.username,
		        	'first_name': this.utente.first_name,
		        	'last_name': this.utente.last_name,
		        	'email': this.utente.email,
		        	'gdpr_email': (this.utente.gdpr_email == 'true') ? 'Yes' : 'No',
		        	'gdpr_advertising': (this.utente.gdpr_advertising == 'true') ? 'Yes' : 'No'
		        }
	        ]
	    }		
	}
</script>
<style scoped>
input[type="checkbox"], input[type="radio"]{
  position: absolute;
  right: 9000px;
}
/*Check box*/
input[type="checkbox"] + .label-text:before{
  content: "\f096";
  font-family: "FontAwesome";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  -webkit-font-smoothing:antialiased;
  width: 1em;
  display: inline-block;
  margin-right: 5px;
  font-size:150%;
  vertical-align: middle;
  color:rgba(0, 0, 0, 0.54);
}

input[type="checkbox"]:checked + .label-text:before{
  content: "\f14a";
  color: #108180;
  animation: effect 250ms ease-in;
}

input[type="checkbox"]:disabled + .label-text{
  color: #aaa;
}

input[type="checkbox"]:disabled + .label-text:before{
  content: "\f0c8";
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/Settings.vue